import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { isPlatformServer } from '@angular/common';

import { LogMessage } from '../models';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  constructor(@Inject(PLATFORM_ID) private platformId: any) {}

  static generateLogMessage(logLevel: string, severityNumber: number, errors: any[]): LogMessage {
    const logMessage: LogMessage = { logLevel };
    if (errors[0] instanceof Error) {
      logMessage.errorType = errors[0].name;
      logMessage.message = errors[0].message;
      logMessage.stacktrace = errors[0].stack;
      if (errors[0]['config']) {
        logMessage.http = {
          method: errors[0]['config']['method']?.toUpperCase(),
          url: errors[0]['config']['url']
        };
        if (errors[0]['config']['headers']) {
          logMessage.http.headers = {};
          Object.entries(errors[0]['config']['headers']).forEach(
            ([key, value]: [string, string]) => (logMessage.http.headers[`${key.toLowerCase()}`] = value)
          );
        }
      }
    } else {
      if (errors.length === 1) {
        const httpError: HttpErrorResponse = errors[0];
        logMessage.errorType = httpError.name;
        logMessage.message = httpError.message;
        logMessage.http = {
          url: httpError.url,
          status: httpError.status,
          statusText: httpError.statusText,
          headers: {}
        };
        httpError.headers
          ?.keys()
          ?.forEach((headerKey) => (logMessage.http.headers[headerKey] = httpError.headers.get(headerKey)));
        if (httpError.error?.errors?.length > 0) {
          const hybrisError = httpError.error.errors[0];
          logMessage.errorType = hybrisError.type;
          logMessage.message = hybrisError.message;
        }
      } else {
        logMessage.body = errors.length > 1 ? errors : errors[0];
      }
    }
    return logMessage;
  }

  logError(...errors: any[]): void {
    if (isPlatformServer(this.platformId)) {
      const logMessage: LogMessage = LoggerService.generateLogMessage('ERROR', 17, errors);
      console.log(JSON.stringify(logMessage));
    } else {
      console.error(...errors);
    }
  }

  logDebug(...errors: any[]): void {
    if (isPlatformServer(this.platformId)) {
      const logMessage: LogMessage = LoggerService.generateLogMessage('DEBUG', 5, errors);
      console.log(JSON.stringify(logMessage));
    } else {
      console.log(...errors);
    }
  }

  logInfo(...errors: any[]): void {
    if (isPlatformServer(this.platformId)) {
      const logMessage: LogMessage = LoggerService.generateLogMessage('INFO', 9, errors);
      console.log(JSON.stringify(logMessage));
    } else {
      console.log(...errors);
    }
  }

  logWarn(...errors: any[]): void {
    if (isPlatformServer(this.platformId)) {
      const logMessage: LogMessage = LoggerService.generateLogMessage('WARN', 13, errors);
      console.log(JSON.stringify(logMessage));
    } else {
      console.warn(...errors);
    }
  }
}
